import React, { Component, PropTypes } from 'react';
import ListSelector from 'components/ListSelector';
import { mixin, RefluxMixin } from 'Util';
import StudentStore from 'stores/Student';
import StudentActions from 'actions/Student';

export default class StudentSelector extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(StudentStore);
  }

  componentDidMount() {
    StudentActions.findReaders();
  }

  reset() {
    this.refs.selector.reset();
  }

  getSelected() {
    return this.refs.selector.getSelected();
  }

  render() {
    return (
      <ListSelector
        ref="selector"
        searchHint={this.context.getIntlMessage('Search')}
        {...this.props}
        loading={this.state.readersLoading}
        items={this.state.readers}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/StudentSelector.js